<template>
  <div
    class="py-8 bg-depth-1 bg-cover bg-center bg-no-repeat bg-fixed"
    style="
      background-image: url('https://ccdn.g-portal.com/Studios_BG_GP_2084f5233b.png');
    "
  >
    <div class="max-w-screen-xl mx-auto px-4 mb-8">
      <h1 class="text-center mb-3 uppercase">{{ component.headline }}</h1>
      <common-md-content
        v-once
        v-slot="{ renderedContent }"
        :content="component.promoText"
      >
        <div class="text-center mb-8 text-lg" v-html="renderedContent"></div>
      </common-md-content>

      <div
        class="py-5 overflow-hidden whitespace-nowrap relative mask-[linear-gradient(to_right,transparent,black_3%,black_97%,transparent)] [-webkit-mask-image:linear-gradient(to_right,transparent,black_3%,black_97%,transparent)]"
      >
        <div
          class="carousel-track flex w-max"
          :style="{ animationDuration: `${duration}s` }"
        >
          <div
            v-for="(image, index) in repeatedImages"
            :key="index"
            class="text-center m-2 p-3 shrink-0 min-w-50 md:min-w-60 max-w-70 bg-onyx/60 rounded-2xl shadow-md text-mouse"
          >
            <strapi-image
              :image="image.image"
              :alt-fallback="image.title"
              class="w-full max-w-50 mx-auto"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { StrapiHomePagePartnersGalleryComponent } from '~/apollo/types/types';

const props = defineProps<{
  component: StrapiHomePagePartnersGalleryComponent;
}>();

const repeatedImages = [...props.component.images, ...props.component.images];
const duration = props.component.images.length * 10;
</script>

<style scoped>
.carousel-track {
  animation: scroll linear infinite;
}

.carousel-track:hover {
  animation-play-state: paused;
}

@keyframes scroll {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-50%);
  }
}

@media (prefers-reduced-motion: reduce) {
  .carousel-track {
    animation-duration: 200s !important;
  }
}
</style>
